import React, { memo } from "react";
import { Box, BoxProps } from "@mui/material";
import Image, { ImageProps } from "next/image";
import { ImagesConstant } from "@/const";
import { StaticImport } from "next/dist/shared/lib/get-img-props";

const AppImage = ({
  width,
  height,
  classes,
  src,
  boxProps,
  children,
  alt = "",
  ...imageProps
}: AppImageProps) => {
  return (
    <Box
      position="relative"
      className={classes?.root}
      width={width || "unset"}
      height={height || "unset"}
      {...boxProps}
    >
      <Image
        src={getUrlImage(src)}
        fill={true}
        draggable={false}
        alt={alt}
        sizes="100%"
        {...imageProps}
      />
      {children}
    </Box>
  );
};

export type AppImageProps = Omit<ImageProps, "width" | "height"> & {
  width?: number | string;
  height?: number | string;
  classes?: {
    root: string;
  };
  boxProps?: BoxProps;
};

export default memo(AppImage);

export const getUrlImage = (value?: string | StaticImport) => {
  if (!value) return "";
  if (typeof value === "string") {
    const regex = /^(\/|https?:\/\/).*/;
    if (regex.test(value)) return value;
  }
  return ImagesConstant.NodataImg;
};
